/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPreSignInData} from '../api'

 export const useQueryGetPreSignInData = createReactQueryHook('getPreSignInData', getPreSignInData)
